module.exports = __webpack_public_path__ + "img/SOKAL-WEB-112322-CreativeAnalysis-Cadillac-Playful.118ff81c.jpeg";